/* Tysk katalog for locale-invoice-control.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'control.expand': 'Chat vergrößern',
  'control.collapse': 'Chat verkleinern',
  'control.proposalIncomplete': 'Der Rechnungsvorschlag ist unvollständig. Zeilen und Details sind nicht ausgefüllt. Gib an, was fehlt, oder vervollständige das Formular.',
  'control.reloadRequired': 'Der Rechnungsmodus wurde aktualisiert. Lade die Seite neu, bevor du fortfährst. Es wurden keine Felder geändert.',
  'control.fieldsApplied': 'Kunde und Rechnungszeilen wurden in das Formular eingetragen. Der Entwurf ist nicht gespeichert.',
  'control.customerApplied': 'Der Kunde ist im Rechnungsformular ausgewählt.',
  'control.onepageApplied': 'Die Ansicht wurde auf „Alles auf einer Seite“ umgestellt.',
  'control.stepsApplied': 'Die Ansicht wurde auf schrittweises Ausfüllen umgestellt.',
  'control.editorOpened': 'Die Seite für einen neuen Verkauf ist geöffnet.',
  'control.listOpened': 'Die Rechnungsliste ist geöffnet.',
  'control.saveReady': 'Der Entwurf kann gespeichert werden, sobald du mich darum bittest.',
  'control.noChange': 'Es wurden keine Felder geändert. Beschreibe, was in die Rechnung eingetragen werden soll.',
  'control.title': 'SuperPlumma erledigt die Arbeit',
  'control.scope': 'Was möchtest du tun?',
  'control.you': 'Du',
  'control.input': 'Was möchtest du tun?',
  'control.run': 'Ausführen',
  'control.speak': 'Sprache',
  'control.stopMic': 'Spracheingabe abbrechen',
  'control.stop': 'Stopp',
  'control.minimize': 'Assistent minimieren',
  'control.newChat': 'Neues Gespräch starten',
  'control.working': 'Plumme arbeitet …',
  'control.saved': 'Der Entwurf ist gespeichert. Die Rechnung wurde nicht versendet.',
  'control.reviewHelp': 'Prüfe die Rechnung in der Vorschau. Verwende „Rechnung erstellen“ und die üblichen Versandoptionen, um abzuschließen.',
  'control.save': 'Entwurf speichern',
  'control.listening': 'Hört zu …',
  'control.voiceUnsupported': 'Dieser Browser unterstützt hier keine Spracheingabe. Du kannst weiterhin schreiben.',
  'control.voiceFailed': 'Die Sprache konnte nicht erkannt werden. Prüfe den Mikrofonzugriff oder schreibe die Nachricht.',
  'control.editorUnavailable': 'Der Rechnungseditor ist nicht verfügbar. Öffne die Rechnung und versuche es erneut.',
  'control.editorChanged': 'Die Rechnung wurde geändert, während ich gearbeitet habe. Bitte erneut um die Änderung, dann verwende ich die neuesten Felder.',
  'control.invoiceOnly': 'Dieser Modus unterstützt Rechnungen. Verwende für andere Aufgaben den normalen Assistenten.',
  'control.agentUnavailable': 'Der Rechnungsmodus benötigt den neuen Assistentendienst, der gerade nicht verfügbar ist. Es wurde keine Änderung vorgenommen.',
  'control.advancedInvoice': 'Diese Rechnung enthält Details, die in der ersten Version im Formular bearbeitet werden müssen. Es wurden keine Felder geändert.',
  'control.customerRequired': 'Wähle einen vorhandenen Kunden oder lege den Kunden zuerst im Kundenregister an.',
  'control.incomplete': 'Wähle einen Kunden und füge vor dem Speichern eine Rechnungszeile hinzu.',
  'control.saveBeforeLeaving': 'Speichere den Entwurf, bevor du zur Rechnungsliste wechselst, damit deine Änderungen erhalten bleiben.',
  'control.failed': 'Die Aufgabe konnte nicht abgeschlossen werden. Versuche es erneut.',
  'pageControl.working': 'Arbeitet auf der Seite ...',
  'pageControl.done.applied': 'Die Felder wurden auf der normalen Seite aktualisiert.',
  'pageControl.done.saved': 'Die Aktion wurde über den normalen Speicherablauf der Seite abgeschlossen.',
});
